import React, { useState } from 'react';

import { Badge } from 'antd';

import { dateMomentFormat } from 'v2/formatters/date';
import type { INotification } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

const ListItemNotification = ({ notification }: { notification: INotification }) => {
  const currentNotification = notificationService.formatNotification(notification);

  const [readed, setReaded] = useState<boolean>(currentNotification.readed);

  const formatedCreateAt = dateMomentFormat(
    new Date(currentNotification.createdAt as string | number | Date),
    'DD/MM/yyyy - HH:mm'
  );

  return (
    <a target='_blank' rel='noopener noreferrer' href={currentNotification.redirect} onClick={() => setReaded(true)}>
      <div className='border-outline-default bg-surface-default text-content-title hover:bg-surface-default flex items-center gap-3 border-b px-4 py-3 transition-colors'>
        <Badge count={readed ? 0 : 1} dot offset={[-2, 2]}>
          <div
            className={`flex size-9 shrink-0 items-center justify-center rounded-full ${currentNotification.color}`}
          >
            <span className='material-icons text-content-title text-lg leading-none'>{currentNotification.icon}</span>
          </div>
        </Badge>
        <div className='min-w-0 flex-1'>
          <div className='text-sm font-medium'>{currentNotification.title}</div>
          <div className='text-content-subtitle truncate text-[0.8125rem]'>{currentNotification.message}</div>
        </div>
        <div className='text-content-caption shrink-0 text-xs whitespace-nowrap'>{formatedCreateAt}</div>
      </div>
    </a>
  );
};
export default ListItemNotification;
